import React from 'react';
import { CSSMailItemHeader, CSSMailItemHeaderFrom } from '../styles';
import { WidgetEmailsImapStatus } from '../WidgetEmailsImapStatus';
import { WidgetEmailsImapDate } from '../JRCWidgetEmailsImapDate';
import { JRCTypography } from 'components/JRCTypography/JRCTypography';

export const WidgetEmailsItemHeader = ({ read, fromName, date }: { read: boolean; fromName: string; date: string }) => {
    return (
        <CSSMailItemHeader>
            <WidgetEmailsImapStatus read={read} />
            <CSSMailItemHeaderFrom>
                <JRCTypography weight="medium" size={'s'}>
                    {fromName}
                </JRCTypography>
            </CSSMailItemHeaderFrom>
            <WidgetEmailsImapDate date={date} read={read} />
        </CSSMailItemHeader>
    );
};
